import { useState, useEffect } from "react";
import { api, trackVisit } from "../lib/api";
import PageHero from "../components/site/PageHero";
import { MapPin, Phone, Clock, MessageCircle } from "lucide-react";
import { toast } from "sonner";

export default function Contatti() {
  const [form, setForm] = useState({ name: "", phone: "", message: "", type: "valutazione" });
  const [sending, setSending] = useState(false);

  useEffect(() => { trackVisit("contatti"); }, []);

  const waText = encodeURIComponent(
    `Salve, sono ${form.name || "[nome]"}. Vorrei un ${form.type} per oro/argento. ${form.message ? "Note: " + form.message : ""}`
  );

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", {
        name: form.name,
        email: null,
        phone: form.phone,
        message: form.message,
        type: form.type,
      });
      toast.success("Richiesta inviata! Ti apriamo WhatsApp con il messaggio pronto.");
      const waMsg = encodeURIComponent(
        `RICHIESTA da ${form.name}\nTelefono: ${form.phone}\nTipo: ${form.type}\n\n${form.message}`
      );
      window.open(`https://wa.me/393389472101?text=${waMsg}`, "_blank");
      setForm({ name: "", phone: "", message: "", type: "valutazione" });
    } catch (err) {
      toast.error("Errore. Riprova o chiama 338 947 2101");
    } finally {
      setSending(false);
    }
  };

  return (
    <div data-testid="contatti-page">
      <PageHero eyebrow="Contatti" title="Una visita." titleAccent="Cento certezze." subtitle="Vieni a trovarci in negozio oppure lasciaci il tuo numero: ti richiamiamo entro 24 ore." />

      <section className="py-16">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2 space-y-5">
            {[
              [MapPin, "Indirizzo", "Via Fratelli Rosselli 265\n41125 Modena (MO)"],
              [Phone, "Telefono", "+39 338 947 2101"],
              [Clock, "Orari", "Lun-Sab 09:00-12:30\n15:30-19:00\nDomenica chiuso"],
            ].map(([Icon, label, value], i) => (
              <div key={i} className="luxe-card p-6 flex gap-4">
                <Icon size={20} className="text-[var(--gold)] shrink-0 mt-1" />
                <div>
                  <div className="text-[0.65rem] uppercase tracking-[0.25em] text-white/40 mb-1">{label}</div>
                  <div className="text-white whitespace-pre-line text-sm">{value}</div>
                </div>
              </div>
            ))}
            <a
              data-testid="contact-whatsapp"
              href={`https://wa.me/393389472101?text=${waText}`}
              target="_blank" rel="noreferrer"
              className="luxe-card p-6 flex gap-4 group hover:border-[#25D366]/40"
            >
              <MessageCircle size={20} className="text-[#25D366] shrink-0 mt-1" />
              <div>
                <div className="text-[0.65rem] uppercase tracking-[0.25em] text-white/40 mb-1">WhatsApp</div>
                <div className="text-white text-sm">Scrivici direttamente</div>
              </div>
            </a>
          </div>

          <form onSubmit={submit} className="lg:col-span-3 luxe-card p-8 space-y-5">
            <h3 className="font-serif text-3xl text-white mb-2">Scrivici</h3>
            <p className="text-sm text-white/50 mb-6">Lascia il tuo numero: ti richiamiamo al più presto.</p>

            <div className="grid md:grid-cols-2 gap-4">
              <input data-testid="contact-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Nome e Cognome *" className="w-full bg-transparent border border-white/15 px-4 py-3 text-white placeholder:text-white/30 focus:border-[var(--gold)] outline-none" />
              <input data-testid="contact-phone" required type="tel" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="Telefono *" className="w-full bg-transparent border border-white/15 px-4 py-3 text-white placeholder:text-white/30 focus:border-[var(--gold)] outline-none" />
            </div>
            <select data-testid="contact-type" value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} className="w-full bg-[#0a1628] border border-white/15 px-4 py-3 text-white focus:border-[var(--gold)] outline-none">
              <option value="valutazione">Valutazione gratuita</option>
              <option value="appuntamento">Appuntamento in negozio</option>
              <option value="info">Richiesta informazioni</option>
            </select>
            <textarea data-testid="contact-message" required rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder="Messaggio *" className="w-full bg-transparent border border-white/15 px-4 py-3 text-white placeholder:text-white/30 focus:border-[var(--gold)] outline-none" />
            <p className="text-xs text-white/40">Inviando questo modulo accetti la nostra <a href="/privacy" className="underline">privacy policy</a>. La richiesta si aprirà su WhatsApp pronta da inviare.</p>
            <button
              type="submit"
              data-testid="contact-submit"
              disabled={sending}
              className="w-full inline-flex items-center justify-center gap-3 px-6 py-4 bg-[#25D366] hover:bg-[#1ebe57] disabled:opacity-60 text-white font-semibold text-sm uppercase tracking-widest rounded-sm transition-colors shadow-lg shadow-green-900/30"
            >
              <MessageCircle size={18} /> {sending ? "Invio..." : "Invia Richiesta via WhatsApp"}
            </button>
          </form>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <iframe
            title="Mappa Affari Oro Modena"
            src="https://www.google.com/maps?q=Via+Fratelli+Rosselli+265,+41125+Modena&output=embed"
            className="w-full h-[420px] border-0 rounded-sm grayscale contrast-125"
            loading="lazy"
          />
        </div>
      </section>
    </div>
  );
}
